
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from "./contexts/AuthContext";
import { SocketProvider } from "./contexts/SocketContext";
import { LoadingProvider } from "./contexts/LoadingContext";
import { Toaster } from 'react-hot-toast';

// Disable console logs in production
if (process.env.NODE_ENV === 'production') {
  console.log = function () { };
  console.warn = function () { };
  console.error = function () { };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <SocketProvider>
        <LoadingProvider>
          <App />
          <Toaster position="top-right" reverseOrder={false} />
        </LoadingProvider>
      </SocketProvider>
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
